import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IReferencesState } from './references.state';

export const getReferencesState = createFeatureSelector<IReferencesState>('references');

export const isBusy = createSelector(
  getReferencesState,
  state => state.isBusy
);

export const getReferences = createSelector(
  getReferencesState,
  state => state.references
);

export const getId = createSelector(
  getReferencesState,
  state => state.id
);
